import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import PropTypes from 'prop-types';
import { getStatusColor } from '../../../contracting/contractingUtils';

import EmptyState from '../empty';
import Timeline from '../widgets/timeline';

const { arrayOf, func, shape, string, array } = PropTypes;

class ContractActivityFeed extends Component {

  onItemClick = (i) => {
    const { data, dispatch } = this.props;
    dispatch(push(`/contracting/contract/${data.timeline[i].contractId}/details`));
  }

  render() {
    const { data } = this.props;
    if (!data.timeline.length) {
      return (<EmptyState message="OooWee! It is a veritable desert out there. A different filter might get you more results." />);
    }
    return (
      <div>
        <div style={{ display: 'flex', flexWrap: 'wrap', borderBottom: '1px solid #efefef', marginBottom: '12px' }}>
          {
            data.stats
            .map((d, i) =>
              (<div key={i} style={{ flex: '1 0 15%', textAlign: 'center' }}>
                <span
                  style={{
                    display: 'block',
                    fontSize: '24px',
                    lineHeight: '40px',
                    color: getStatusColor(d.label),
                  }}
                >
                  {d.value}
                </span>
                <span
                  style={{
                    display: 'block',
                    fontSize: '14px',
                    textTransform: 'capitalize',
                    color: getStatusColor(d.label),
                  }}
                >
                  {d.label}
                </span>
                <div className="flex-center" style={{ flexDirection: 'column', display: d.updates ? 'flex' : 'none', justifyContent: 'center', marginBottom: '12px' }}>
                  <small>{d.updates} Updates</small>
                </div>
              </div>))
          }
        </div>
        <Timeline feed={data.timeline} onItemClick={this.onItemClick} />
      </div>
    );
  }
}

ContractActivityFeed.propTypes = {
  data: shape({
    stats: array.isRequired,
    timeline: arrayOf(shape({
      label: string.isRequired,
      contractId: string.isRequired,
      timestamp: string.isRequired,
    })).isRequired,
  }).isRequired,
  dispatch: func,
};

export default connect()(ContractActivityFeed);



// WEBPACK FOOTER //
// ./src/app/components/contracting-dashboard/components/charts/contractActivityFeed.jsx